import React from 'react';
import { istToday, shiftDay } from '../lib';

/** Today · 7 · 14 · 30 days, then the custom range — the one IST date bar
 *  every page shares. A preset lights up while the range still matches it;
 *  arrows slide the whole window by a day; edits keep from ≤ to. */
const PRESETS: { label: string; days: number }[] = [
  { label: 'Today', days: 1 }, { label: '7 days', days: 7 }, { label: '14 days', days: 14 }, { label: '30 days', days: 30 },
];

const inputCls =
  'h-8 px-2.5 rounded-lg border border-charcoal/15 bg-warm-white text-[13px] font-medium focus:outline-none focus:border-forest focus:ring-2 focus:ring-sage/40';
const arrowCls =
  'w-8 h-8 rounded-lg grid place-items-center text-graphite hover:text-charcoal hover:bg-charcoal/5 disabled:opacity-30 disabled:hover:bg-transparent';

const DateRangeBar: React.FC<{
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
  caption?: string;
}> = ({ from, to, onChange, caption }) => {
  const today = istToday();
  const active = (days: number) => to === today && from === shiftDay(today, -(days - 1));
  return (
    <div className="flex items-center gap-2 flex-wrap mb-8">
      <span className="inline-flex rounded-lg bg-charcoal/[0.06] p-0.5">
        {PRESETS.map((p) => (
          <button
            key={p.days}
            onClick={() => onChange(shiftDay(today, -(p.days - 1)), today)}
            className={`px-3 py-1 rounded-md text-[13px] font-semibold transition-colors ${
              active(p.days) ? 'bg-warm-white text-charcoal shadow-[0_1px_2px_rgba(61,61,61,0.15)]' : 'text-graphite hover:text-charcoal'}`}
          >
            {p.label}
          </button>
        ))}
      </span>
      <span className="inline-flex items-center gap-1 ml-2">
        <button onClick={() => onChange(shiftDay(from, -1), shiftDay(to, -1))} className={arrowCls} aria-label="a day earlier">‹</button>
        <input type="date" value={from}
               onChange={(e) => e.target.value && onChange(e.target.value, e.target.value > to ? e.target.value : to)}
               className={inputCls} />
        <span className="text-graphite/60 text-sm px-0.5">–</span>
        <input type="date" value={to}
               onChange={(e) => e.target.value && onChange(e.target.value < from ? e.target.value : from, e.target.value)}
               className={inputCls} />
        <button onClick={() => onChange(shiftDay(from, 1), shiftDay(to, 1))} disabled={to >= today} className={arrowCls} aria-label="a day later">›</button>
      </span>
      {caption && <span className="text-graphite text-[12.5px] ml-auto">{caption}</span>}
    </div>
  );
};

export default DateRangeBar;
